import styled, { css } from 'styled-components';

export const TopBarWrapper = styled.nav`
  background: #0d0d0d;
  color: #ffffff;
  padding: 0 1rem;

  display: none;
  @media (min-width: 1025px) {
    display: block;
  }

  .top-bar-grid {
    display: grid;
    grid-template-columns: 94px 1fr;

    max-width: 1240px;
    margin: 0 auto;

    .top-bar-column-2 {
      display: flex;
      justify-content: space-between;
      grid-column: 2;

      a {
        display: flex;
        padding: 0.5rem 1.25rem;
        font-size: 0.875rem;
        line-height: 1.125rem;
      }

      ul {
        display: flex;
      }
    }
  }
`;

export const TopBarNavigationItem = styled.a<{ isSelected: boolean }>`
  ${props =>
    props.isSelected &&
    css`
      background: #ffffff !important;
      color: #0d0d0d !important;
      font-weight: 700 !important;
    `}
`;